// src/pages/Authentication/ChangePassword/PasswordInput.tsx
// Reusable password input component with show/hide toggle

import React, { useState } from 'react';
import { Input, Label, FormFeedback, FormGroup } from 'reactstrap';

interface PasswordInputProps {
  name: string;
  label: string;
  placeholder: string;
  value: string;
  error?: string;
  touched?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  name,
  label,
  placeholder,
  value,
  error,
  touched,
  onChange,
  onBlur,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <FormGroup>
      <Label htmlFor={name} className="form-label">
        {label} <span className="text-danger">*</span>
      </Label>
      <div className="position-relative auth-pass-inputgroup">
        <Input
          type={showPassword ? 'text' : 'password'}
          name={name}
          id={name}
          className="form-control pe-5"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          invalid={touched && !!error}
        />
        <button
          type="button"
          className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
          onClick={togglePasswordVisibility}
          style={{ zIndex: 10 }}
        >
          <i className={`ri-eye-${showPassword ? 'off' : 'fill'}-line align-middle`}></i>
        </button>
        {touched && error && <FormFeedback>{error}</FormFeedback>}
      </div>
    </FormGroup>
  );
};

export default PasswordInput;